import { actionFactory } from 'redux/factories';
import { types } from './types';

export const syncNotifications = actionFactory(types.SYNC_NOTIFICATIONS);
export const clearNotificationsStore = actionFactory(types.CLEAR_NOTIFICATIONS);
export const refreshNotifications = actionFactory(
  types.REFRESH_SYNC_NOTIFICATIONS,
);
